import globals from '@insided/deprecated-utils/globals'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import { PureComponent } from 'preact-compat'

export interface EmptyViewProps {
  EmptyStateComponent: JSX.Element
  loading: boolean
  showNoResultFound?: boolean
}

class EmptyView extends PureComponent<EmptyViewProps> {
  render() {
    const { EmptyStateComponent, loading, showNoResultFound } = this.props

    const emptyPageUrl: string = `${globals('basePath')}images/empty_result.png`

    if (loading) {
      return null
    }

    return (showNoResultFound) ? (
      <EmptyPage
        img_src={emptyPageUrl}
        header='No results found'
        text={'Sorry, that filter combination has no results.\n Please try different criteria.'}
      />
    ) : EmptyStateComponent
  }
}

export default EmptyView
